// extracted by mini-css-extract-plugin
module.exports = {"description":"style__description__3JE2N"};